import React, { memo, useEffect, useState } from "react";
import { validators } from "investira.sdk";
import { Stack, CircularProgress, Typography, Divider, Button, Chip } from "investira.react.components";
import withResponseHandling from "../../../hoc/withResponseHandling";
import SearchPrincipalItem from "./SearchPrincipalItem";
import { ATIVO_MERCADO } from "@investirapri/financa.js/lib/enums";
/**
 * Renderiza o componente SearchPrincipalResultado.
 *
 * @param {Object} props - Propriedades do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const SearchPrincipalResultado = memo(props => {
  const {
    isLoading,
    data,
    message,
    size,
    onClick,
    onSearch
  } = props;
  const [tabs, setTabs] = useState([]);
  const [openTab, setOpenTab] = useState(null);
  const [resultado, setResultado] = useState(null);

  // Função para separar um array de objetos pelo atributo "pesquisa_origem"
  function separarPorPesquisaOrigem(pArr) {
    if (!pArr || !Array.isArray(pArr) || pArr.length === 0) {
      return {};
    }
    return pArr.reduce((xAcc, xObj) => {
      let chave;
      if (xObj.pesquisa_origem === "ativo") {
        chave = xObj.mercado || "indefinido";
      } else {
        chave = xObj.pesquisa_origem || "indefinido";
      }
      if (!xAcc[chave]) {
        xAcc[chave] = [];
      }
      xAcc[chave].push(xObj);

      // Ordena as chaves conforme instrução: "ativo" (ordem alfabética dos mercados), "pessoa", "indicador"
      // Primeiro, armazena os ativos separadamente para ordenar depois
      const ativos = {};
      const pessoas = {};
      const indicadores = {};
      const outros = {};
      Object.entries(xAcc).forEach(([chave, valor]) => {
        if (chave !== "pessoa" && chave !== "indicador" && chave !== "indefinido" && ATIVO_MERCADO[chave]) {
          ativos[chave] = valor;
        } else if (chave === "pessoa") {
          pessoas[chave] = valor;
        } else if (chave === "indicador") {
          indicadores[chave] = valor;
        } else {
          outros[chave] = valor;
        }
      });

      // Ordena as chaves dos ativos em ordem alfabética
      const ativosOrdenados = Object.keys(ativos).sort().reduce((acc, key) => {
        acc[key] = ativos[key];
        return acc;
      }, {});

      // Junta tudo na ordem desejada
      const resultadoOrdenado = {
        ...pessoas,
        ...ativosOrdenados,
        ...indicadores,
        ...outros
      };
      return resultadoOrdenado;
    }, {});
  }
  const xTabLabel = {
    ...ATIVO_MERCADO,
    pessoa: {
      id: "pessoa",
      descricao: "Empresa"
    },
    indicador: {
      id: "indicador",
      descricao: "Indicador"
    },
    indefinido: {
      id: "indefinido",
      descricao: "Outros"
    }
  };
  useEffect(() => {
    if (!validators.isEmpty(data)) {
      const xResultado = separarPorPesquisaOrigem(data);
      const xTabs = Object.keys(xResultado);
      setResultado(xResultado);
      setTabs(xTabs);
      setOpenTab(xTabs[0]);
    }
  }, [data]);
  return <>
      <Stack>
        {!isLoading && !validators.isEmpty(data) && !validators.isEmpty(resultado) && <>
              <Stack direction="row" spacing={1} sx={{
          px: 2,
          py: 1
        }}>
                {tabs.map(key => <Chip key={key} label={xTabLabel[key].descricao} color={openTab === key ? "primary" : "default"} onClick={() => setOpenTab(key)} clickable size={"small"} sx={{
            textTransform: "capitalize"
          }} />)}
              </Stack>

              <Divider sx={{
          mb: 1
        }} />

              {tabs.map(key => openTab === key && <>
                      <Stack id={`busca-list-${key}`} sx={{
            px: 0
          }} component="ul" key={key}>
                        {Array.isArray(resultado[key]) && resultado[key].slice(0, size).map(xItem => <SearchPrincipalItem key={crypto.randomUUID()} data={xItem} onClick={e => onClick(e, xItem, props.clearOnClose)} />)}
                      </Stack>

                      {key !== "indicador" && <Stack sx={{
            px: 2,
            py: 2,
            alignItems: "center"
          }}>
                          <Button variant="contained" onClick={() => onSearch(resultado[key][0].pesquisa_origem, resultado[key][0].mercado)} sx={{
              maxWidth: "500px",
              px: 4
            }}>
                            Visualizar Todos
                          </Button>
                        </Stack>}
                    </>)}
            </>}

        {isLoading && <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{
        py: 2
      }}>
            <CircularProgress size={24} />
          </Stack>}

        {!isLoading && validators.isEmpty(data) && <Stack justifyContent="center" alignItems="center" flexGrow={1} sx={{
        py: 2
      }}>
            <Typography variant="body2" color="textPrimary">
              {message}
            </Typography>
          </Stack>}
      </Stack>
    </>;
});
export default withResponseHandling(SearchPrincipalResultado);
